import { Stack } from 'ui-components';
import { BasicStoreFragment, useGetStoresQuery } from 'drycut-graphql';
import SalonCard from './SalonCard';

export function SalonIndex(): JSX.Element {
  const { data } = useGetStoresQuery();

  const stores = data?.stores?.nodes || [];
  const validStores = stores.filter((node): node is BasicStoreFragment => Boolean(node));

  return (
    <Stack className="h-screen justify-center p-10 items-center">
      <div className="grid grid-cols-2 gap-10 container">
        {validStores.map((store) => (
          <SalonCard key={store.id} salon={store} />
        ))}
      </div>
    </Stack>
  );
}
